import { Box, TextField, Typography } from "@mui/material";
import { handleNodeState } from "common/constants/functions";
import { useAppSelector } from "common/hooks";
import _ from "lodash";
import { useEffect, useState } from "react";
import SearchableSelect from "./SearchableSelect";

const Substitutions = ({ nodeState, setNodeState, propKey }: any) => {
  const { nodeToEdit } = useAppSelector((state) => state.nodes);
  const title =
    nodeState?.data?.properties?.[propKey]?.ifValue +
    " " +
    nodeState?.data?.properties?.[propKey]?.elseValue;
  const [substitutions, setSubstitutions] = useState<any>([]);

  useEffect(() => {
    const substitutionsObj = _.reduce(
      substitutions,
      (result: any, item: any) => {
        result[item.key] = item.value;
        return result;
      },
      {}
    );
    handleNodeState(
      ["data", "properties", `${propKey}`, "substitutions"],
      substitutionsObj,
      setNodeState
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [substitutions, propKey]);
  const handleSubstitutionChange = ({ target: { name, value } }: any, i: number) => {
    setSubstitutions((prev: any) =>
      prev.map((sub: any, index: number) => (index === i ? { ...sub, [name]: value } : sub))
    );
  };

  useEffect(() => {
    const regex = /\[([A-Za-z][A-Za-z0-9_]*?)\]/g;

    const matches: any[] = [];
    let match;

    while ((match = regex.exec(title)) !== null) {
      matches.push(match[1]);
    }

    const updatedState = [
      ...substitutions.filter((s: any) => matches.includes(s.key)), // Keep items that are in newKeys
      ...matches
        .filter((key) => !substitutions.some((s: any) => s.key === key)) // Add new keys
        .map((key) => ({ key, value: "" })), // Convert new keys into objects
    ];

    setSubstitutions(updatedState);
    // eslint-disable-next-line
  }, [title]);
  useEffect(() => {
    const INITIAL_SUBSTITUTIONS = _.map(
      nodeToEdit?.data?.properties?.[propKey]?.substitutions,
      (value, key) => ({ key, value })
    );
    setSubstitutions(INITIAL_SUBSTITUTIONS);
    // eslint-disable-next-line
  }, [nodeToEdit]);
  return substitutions?.length ? (
    <>
      <Typography variant="subtitle2" sx={{ mt: 1 }}>
        Substitutions
      </Typography>
      {substitutions?.map((val: any, i: number) => (
        <Box sx={{ display: "flex", gap: 1 }} key={i}>
          <TextField
            required
            margin="dense"
            name="key"
            label="Key"
            type="text"
            value={val?.key}
            fullWidth
            disabled
            onChange={(e: any) => handleSubstitutionChange(e, i)}
          />
          <SearchableSelect
            name="value"
            value={val?.value}
            onChange={(e: any) => handleSubstitutionChange(e, i)}
          />
        </Box>
      ))}
    </>
  ) : null;
};

export default Substitutions;
